// The last scope of the session, in the browser's session storage: the
// selection (as Explore writes it, without the view and its settings) the
// analytics page was last opened on. The sidebar entry reopens it; without
// one it opens on every product.

const KEY = "aa.analytics.scope";

// The query string of the last scope, without the "?"; empty for none or
// where the storage cannot be read
export const rememberedScope = (): string => {
  try {
    return window.sessionStorage.getItem(KEY) ?? "";
  } catch {
    return "";
  }
};

// Remembers the query string of a scope, or forgets it when it is empty
export const rememberScope = (query: string): void => {
  try {
    if (query) {
      window.sessionStorage.setItem(KEY, query);
    } else {
      window.sessionStorage.removeItem(KEY);
    }
  } catch {
    // A full or blocked storage keeps nothing; the address still does
  }
};

// The address the sidebar entry opens: the page on the last scope
export const rememberedScopeAddress = (path: string): string => {
  const query = rememberedScope();
  return query ? `${path}?${query}` : path;
};
